import { MensajesGenericos_EN } from "./Genericos/DiccionarioMensajesGenericos_EN";
import { DiccionarioAcademico_EN } from "./DiccionariosAreas/DiccionarioAcademico_EN";
import { DiccionarioSeguridad_EN } from "./DiccionariosAreas/DiccionarioSeguridad_EN";
import { DiccionarioLogin_EN } from "./DiccionariosAreas/DiccionarioLogin_EN";
import { DiccionarioCajas_EN } from "./DiccionariosAreas/DiccionarioCajas_EN";

const DiccionarioInterno = [
  {
    codigo: "ErrorValidUUID",
    mensaje: "Invalid validation token.",
  },
  {
    codigo: "ErrorValidFormatUUID",
    mensaje: "Invalid validation token format.",
  },
  {
    codigo: "ErrorRequiredEmail",
    mensaje:
      "There is no email associated with your user account. Contact administration.",
  },
  {
    codigo: "SussesEmailSend",
    mensaje: "Verification code successfully sent to your email account.",
  },
  {
    codigo: "ErrorExistsClient",
    mensaje: "Another student with that identification already exists.",
  },
  {
    codigo: "DuplicateCustomerEmailNI",
    mensaje:
      "The entered email address is not available. Contact administration.",
  },
  {
    codigo: "NoFileRules",
    mensaje: "File does not comply with configuration rules.",
  },
  {
    codigo: "InvalidEmailFormat",
    mensaje: "The entered email address is not valid.",
  },
  {
    codigo: "ErrorValidatingEmail",
    mensaje: "An error occurred while validating the email. Please try again.",
  },
  {
    codigo: "VerificationCodeSent",
    mensaje: "Verification code sent to your email address.",
  },
  {
    codigo: "VerificationCodeInvalid",
    mensaje: "Invalid verification code.",
  },
  {
    codigo: "VerificationCodeExpired",
    mensaje: "The code has expired. Request a new one.",
  },
  {
    codigo: "VerificationCodeSuccess",
    mensaje: "Email verified successfully.",
  },
  {
    codigo: "CancelVerificationCodeSuccess",
    mensaje: "The verification code has been cancelled successfully.",
  },
  {
    codigo: "CancelVerificationCodeError",
    mensaje: "Error cancelling verification code.",
  },
  {
    codigo: "VerificationCodeAlreadyUsed",
    mensaje: "This code has already been used.",
  },
  {
    codigo: "VerificationCodeError",
    mensaje: "Error verifying code. Please try again.",
  },
  {
    codigo: "SuccessRegister",
    mensaje: "The record has been successfully registered.",
  },
  {
    codigo: "ErrorValidatingIdentification",
    mensaje:
      "An error occurred while validating the identification. Please try again.",
  },
  {
    codigo: "ErrorProviderNotConfiguredOrInactive",
    mensaje: "The service provider is not configured or is inactive.",
  },
  {
    codigo: "ValidationProviderError",
    mensaje:
      "An error occurred while validating the identification with the provider. Please try again.",
  },
  {
    codigo: "ErrorIdentificationAlreadyExists",
    mensaje:
      "The entered identification already exists. Please enter a different one.",
  },
  {
    codigo: "ErrorIdentificationNotFound",
    mensaje: "No record was found with the entered identification.",
  },
  {
    codigo: "ErrorCUIIsMinor",
    mensaje:
      "The ID is associated with a minor, please complete the data manually.",
  },
];

export const DiccionarioMensajes_EN = [
  ...DiccionarioInterno,
  ...MensajesGenericos_EN,
  ...DiccionarioLogin_EN,
  ...DiccionarioAcademico_EN,
  ...DiccionarioSeguridad_EN,
  ...DiccionarioCajas_EN,
];
